<div class="loader_session"  *ngIf='loaderdata'>
    <div class="loader-4"><span></span>
  </div>
  </div>
  <div class="search mt-5">
    <div class="row">
      <div class="col-md-6">
        <form [formGroup]="form"  (ngSubmit)="getsearchitem()">
          <div class="input-group mb-3 searchitem" >
            <input type="text" class="form-control" placeholder="Search by Surname"  formControlName="search" aria-label="Recipient's username" aria-describedby="basic-addon2">
            <div class="input-group-append">
              <button type="submit" class="input-group-text"><i class="fa fa-search" aria-hidden="true"></i>&nbsp;Search</button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
  <div class="table-responsive mt-2 ">
<table class="table  ">
    <thead class="thead-dark">
      <tr>
        <!-- <th scope="col">#</th> -->
        <th scope="col">Name</th>
        <th scope="col">Email</th>
      </tr>
    </thead>
    <tbody>
     
      <tr *ngFor="let item of data| paginate: { itemsPerPage: 10, currentPage: p }; index as i;  ">
        <!-- <th scope="row">{{i+p}} {{p}}</th> -->
        <td>{{item.Name}} {{item.last}}</td>
        <td>{{item.email}}</td>
      </tr>
 
    </tbody>
  </table>
</div>
<pagination-controls class="pagination justify-content-end my-5"

(pageChange)="p = $event"></pagination-controls>

<!-- <div *ngIf="pagination">
  <ul class="pagination justify-content-end my-5" >
    <li class="page-item"><a class="page-link" style="cursor: pointer;" (click)="clickprev(last)">Previous</a></li>
    <li class="page-item"><a class="page-link" style="cursor: pointer;" (click)="clicknext(last)">Next</a></li>
  </ul>
</div> -->